const data = [
	{
		Books: `Software Testing & Quality Assurance ( Computer)
		`,
	},
	{
		Books: `System Operation & Maintenance (IT)`,
	},
	{
		Books: `Discrete Structure (Computer)`,
	},
	{
		Books: `Software Testing & Quality Assurance (IT)`,
	},
	{
		Books: `Discrete Structure (IT)`,
	},
];

export default data;
